
import { useGlobalStore } from '@/modules/globalModule/store';
import { defineComponent } from 'vue';
import { useNodeCanvasStore } from '../store';
import { Node } from './storeClasses/node';
import { Topic } from './storeClasses/topic';

export default defineComponent({
  name: 'AddTopicConnectionPrompt',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ncStore: useNodeCanvasStore(),
      node: null as unknown as Node | undefined,
      topic: null as unknown as Topic | undefined,
      nodeName: String as unknown as string | undefined,
      topicName: String as unknown as string | undefined
    };
  },
  methods: {
    open() {
      const globalStore = useGlobalStore();
      if (
        !this.ncStore.connectingTopicNode ||
        !this.ncStore.connectingTopicNode.topic ||
        !this.ncStore.connectingTopicNode.node
      )
        return;
      this.topic = globalStore.getTopic(this.ncStore.connectingTopicNode.topic);
      this.node = globalStore.getNode(this.ncStore.connectingTopicNode.node);
      if (!this.topic || !this.node) {
        this.exit();
        return;
      }
      this.nodeName = this.node.name;
      this.topicName = this.topic.name;
    },
    exit() {
      this.ncStore.connectingTopicNode = undefined;
    },
    addSubscriber() {
      if (!this.node || !this.topic) return;
      this.node.addSubscriber(this.topic.id);
    },
    addPublisher() {
      if (!this.node || !this.topic) return;
      this.node.addPublisher(this.topic.id);
    },
    removeSubscriber() {
      if (!this.node || !this.topic) return;
      this.node.removeSubscriber(this.topic.id);
    },
    removePublisher() {
      if (!this.node || !this.topic) return;
      this.node.removePublisher(this.topic.id);
    },
    addBoth() {
      if (!this.node || !this.topic) return;
      this.node.addSubscriber(this.topic.id);
      this.node.addPublisher(this.topic.id);
    },
    removeBoth() {
      if (!this.node || !this.topic) return;
      this.node.removePublisher(this.topic.id);
      this.node.removeSubscriber(this.topic.id);
    }
  },
  watch: {
    active() {
      if (this.active) this.open();
    }
  }
});
